import React, { FC, memo } from 'react';
import styled from '@emotion/styled';
import { Box } from '~Styles';
import Icon from '~ComponentsImproved/Icon';
import Paragraph from '~ComponentsImproved/Typography/Paragraph';
import WifiIcon from '~Assets/icons/wifi.svg';
import WifiUnstableIcon from '~Assets/icons/wifi_2_bar.svg';
import WifiDownIcon from '~Assets/icons/wifi_3_bar.svg';
import { useSelector } from '~Hooks';

const UNSTABLE_LATENCY_MS = 150;

/** Parent must be positioned */
const Wrapper = styled(Box)`
  position: absolute;
  top: 24px;
  right: 16px;
`;

/** Internet health based on the socket ping/pong */
const InternetStatus: FC = () => {
  /** null means no ping has completed yet */
  const hasInternetConnection = useSelector((state) => state.socketConnection.connected);
  const latencyMs = useSelector((state) => state.socketConnection.latencyMs);

  const isUnknown = hasInternetConnection === null;
  const isUnstable = latencyMs !== null && latencyMs > UNSTABLE_LATENCY_MS;

  const icon =
    hasInternetConnection === false ? WifiDownIcon : isUnstable ? WifiUnstableIcon : WifiIcon;
  const color = isUnknown
    ? 'var(--colorBlueGray600)'
    : !hasInternetConnection
    ? 'var(--colorUIRed)'
    : isUnstable
    ? 'var(--colorUIOrange)'
    : 'var(--colorUIGreen)';

  return (
    <Wrapper display="flex" alignItems="center" gap="xs">
      <Icon src={icon} color={color} />
      {hasInternetConnection && latencyMs !== null && (
        <Paragraph level={5} color="var(--colorBlueGray1200)">
          {latencyMs} ms
        </Paragraph>
      )}
    </Wrapper>
  );
};

export default memo(InternetStatus);
